import { RankEntry, SessionResult } from './types';
import type { Platform } from './types';

const KEY = 'esports_fitness_rank_v1';
const MAX = 20;

export function loadRanks(platform: Platform): RankEntry[] {
  try {
    const raw = platform.storageGet(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as RankEntry[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveSessionRank(platform: Platform, session: SessionResult): RankEntry[] {
  const entry: RankEntry = {
    score: session.score,
    rank: session.rank,
    srtMeanMs: session.srtMeanMs,
    createdAt: session.createdAt,
    platform: session.platform,
    suspect: session.suspect,
  };
  const list = loadRanks(platform);
  list.push(entry);
  list.sort((a, b) => {
    if (b.score !== a.score) return b.score - a.score;
    const sa = a.srtMeanMs ?? 9999;
    const sb = b.srtMeanMs ?? 9999;
    if (sa !== sb) return sa - sb;
    return a.createdAt - b.createdAt;
  });
  const trimmed = list.slice(0, MAX);
  platform.storageSet(KEY, JSON.stringify(trimmed));
  return trimmed;
}

export function bestScore(platform: Platform): RankEntry | null {
  const list = loadRanks(platform);
  return list[0] ?? null;
}
